/**
 * Articles content — kept in a single source of truth so the index page and
 * individual article pages stay in sync. Each article also exports its own
 * dedicated React component for rich content & SEO-friendly URLs.
 */

export const ARTICLES = [
  {
    slug: "run-flat-bmw",
    title: "O melhor pneu para o meu BMW: Run-Flat ou pneu normal?",
    excerpt:
      "BMWs Série 3, Série 5 ou X3/X5 vêm de fábrica com pneus Run-Flat. Vale a pena manter? Comparamos preço, conforto, segurança e durabilidade contra os pneus normais.",
    tag: "BMW · Premium",
    readTime: "6 min",
    image: "/tires/michelin-primacy-5.png",
  },
  {
    slug: "hankook-prime4-vs-michelin-primacy5",
    title: "Hankook Ventus Prime 4 vs Michelin Primacy 5: qual escolher?",
    excerpt:
      "Confronto direto entre dois dos pneus de turismo mais procurados em 205/55 R16 e 225/45 R17. Qual trava melhor em chuva? Qual dura mais? Qual oferece melhor relação qualidade/preço?",
    tag: "Comparativo · 2026",
    readTime: "8 min",
    image: "/tires/hankook-ventus-prime4.png",
  },
];
